/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React from 'react'
// @ts-ignore
import { components } from 'react-select'
import { CloseBtn } from 'Stories/CloseBtn/CloseBtn.stories'
import { Desktop } from 'Shared/components/Responsive'

export const DropdownIndicator = (props: JSX.IntrinsicAttributes) => (
  <components.DropdownIndicator {...props}>
    <Desktop>
      <CloseBtn content="X" />
    </Desktop>
  </components.DropdownIndicator>
)
